import React from "react";
import RequestPriceList from "./requestPriceList/RequestPriceList";

const RequestPrice = () => {
  return <RequestPriceList />;
};

export default RequestPrice;
